exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.i(require("-!../../../../../node_modules/css-loader/index.js!vue-directive-tooltip/css/index.css"), "");

// module
exports.push([module.id, "@media only screen and (min-width: 0px) and (max-width: 559px) {\n.pdp-playground-modal[data-v-746c94b6] {\n    height: 100%;\n    width: 100%;\n    overflow: auto;\n}\n}\n", ""]);

// exports
